export default {
  home: "/:lan/",
  human: "/:lan/human",
  earth: "/:lan/earth",
  god: "/god",
};
